import React from 'react'
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
const ColoredButton = ({buttonText, className, onClick=()=>{}, disabled=false}) => {
  const [isDisable, setIsDisable] = useState(false);
  function onClickHandler(){
    setIsDisable(true);
    setTimeout(() => {
      setIsDisable(false);
    },500)
    onClick()
  }
  return (
    <>
        <Button className={`primaryBtn ${className}`} onClick={onClickHandler} disabled={(disabled || isDisable)}>{buttonText}</Button>
    </>
  )
}

export default ColoredButton